var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirefox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: "87.25%",
    x2: "9.4%",
    y1: "15.5%",
    y2: "93.1%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3647",
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e31587",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: "87.4%",
    cy: "-12.9%",
    r: "128%",
    gradientTransform: "translate(.874) scale(.8 1) translate(-.87 .129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbd4f",
    offset: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3750",
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eb0878",
    offset: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e50080",
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "49%",
    cy: "40%",
    r: "128%",
    gradientTransform: "translate(.49 .4) scale(.82 1) translate(-.49 -.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960e18",
    offset: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b11927",
    stopOpacity: 0.74,
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#db293d",
    stopOpacity: 0.34,
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5334b",
    stopOpacity: 0.09,
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3750",
    stopOpacity: 0,
    offset: 0.53
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: "48%",
    cy: "-12%",
    r: "140%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.53
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: "22.76%",
    cy: "110.11%",
    r: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3a8ee6",
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9059ff",
    offset: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c139e6",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: "52%",
    cy: "33%",
    r: "59%",
    gradientTransform: "scale(.9,1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9059ff",
    stopOpacity: 0,
    offset: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6e008b",
    stopOpacity: 0.6,
    offset: 0.97
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: "210%",
    cy: "-100%",
    r: "290%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe226",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7139",
    offset: 0.79
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: "84%",
    cy: "-41%",
    r: "180%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3647",
    offset: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e31587",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: "16.1%",
    cy: "-18.6%",
    r: "348.8%",
    gradientTransform: "translate(.16 -.19) scale(1 .47) rotate(84) translate(-.16 .19)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3647",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e31587",
    offset: 0.74
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: "18.9%",
    cy: "-42.5%",
    r: "238.4%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3647",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e31587",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: "159.3%",
    cy: "-44.72%",
    r: "313.1%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: "80%",
    x2: "18%",
    y1: "14%",
    y2: "84%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    stopOpacity: 0.8,
    offset: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    stopOpacity: 0,
    offset: 0.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m478.71 166.35c-10.445-25.124-31.6-52.248-48.212-60.821 13.52 26.505 21.345 53.093 24.335 72.936 0 0.039 0.015 0.136 0.047 0.4-27.175-67.733-73.254-95.045-110.88-154.51-1.9-3.007-3.805-6.022-5.661-9.2a73.716 73.716 0 0 1-2.646-4.972 43.7 43.7 0 0 1-3.593-9.506 0.626 0.626 0 0 0-0.546-0.644 0.818 0.818 0 0 0-0.451 0c-0.034 0.012-0.084 0.051-0.12 0.065-0.053 0.021-0.12 0.069-0.176 0.1 0.027-0.036 0.083-0.117 0.1-0.136-60.37 35.356-80.85 100.76-82.732 133.48a120.25 120.25 0 0 0-66.142 25.488 71.355 71.355 0 0 0-6.225-4.7 111.34 111.34 0 0 1-0.674-58.732c-24.688 11.241-43.89 29.01-57.85 44.7h-0.111c-9.527-12.067-8.855-51.873-8.312-60.184-0.114-0.515-7.107 3.63-8.023 4.255a175.07 175.07 0 0 0-23.486 20.12 210.48 210.48 0 0 0-22.442 26.913c0 0.012-7e-3 0.026-0.011 0.038 0-0.013 7e-3 -0.026 0.011-0.038a202.84 202.84 0 0 0-32.247 72.805c-0.115 0.521-0.212 1.061-0.324 1.586-0.452 2.116-2.08 12.7-2.365 15-0.022 0.177-0.032 0.347-0.053 0.524a229.07 229.07 0 0 0-3.9 33.157c0 0.41-0.025 0.816-0.025 1.227 4e-3 132.71 107.6 240.3 240.33 240.3 118.86 0 217.56-86.288 236.88-199.63 0.407-3.076 0.733-6.168 1.092-9.271 4.777-41.21-0.53-84.525-15.587-120.75zm-277 188.09c1.124 0.537 2.18 1.124 3.334 1.639 0.048 0.033 0.114 0.07 0.163 0.1a126.19 126.19 0 0 1-3.497-1.739zm55.053-144.93m198.13-30.59-0.032-0.233c0.012 0.085 0.027 0.174 0.04 0.259z",
    fill: "url(#x)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m478.71 166.35c-10.445-25.124-31.6-52.248-48.212-60.821 13.52 26.505 21.345 53.093 24.335 72.936 0-0.058 0.011 0.048 0.036 0.226 0.012 0.085 0.027 0.174 0.04 0.259 22.675 61.47 10.322 123.98-7.479 162.18-27.539 59.1-94.215 119.67-198.58 116.72-112.76-3.193-212.09-86.856-230.63-196.43-3.379-17.28 0-26.054 1.7-40.084-2.071 10.816-2.86 13.94-3.9 33.157 0 0.41-0.025 0.816-0.025 1.227 2e-3 132.71 107.6 240.29 240.33 240.29 118.86 0 217.56-86.288 236.88-199.63 0.407-3.076 0.733-6.168 1.092-9.271 4.777-41.21-0.53-84.525-15.587-120.75z",
    fill: "url(#w)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m478.71 166.35c-10.445-25.124-31.6-52.248-48.212-60.821 13.52 26.505 21.345 53.093 24.335 72.936 0-0.058 0.011 0.048 0.036 0.226 0.012 0.085 0.027 0.174 0.04 0.259 22.675 61.47 10.322 123.98-7.479 162.18-27.539 59.1-94.215 119.67-198.58 116.72-112.76-3.193-212.09-86.856-230.63-196.43-3.379-17.28 0-26.054 1.7-40.084-2.071 10.816-2.86 13.94-3.9 33.157 0 0.41-0.025 0.816-0.025 1.227 2e-3 132.71 107.6 240.29 240.33 240.29 118.86 0 217.56-86.288 236.88-199.63 0.407-3.076 0.733-6.168 1.092-9.271 4.777-41.21-0.53-84.525-15.587-120.75z",
    fill: "url(#v)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m361.92 194.6c0.524 0.368 1 0.734 1.493 1.1a130.71 130.71 0 0 0-22.31-29.112c-74.705-74.696-19.589-161.96-10.294-166.39 0.027-0.036 0.083-0.117 0.1-0.136-60.37 35.356-80.85 100.76-82.732 133.48 2.8-0.194 5.592-0.429 8.442-0.429 45.051 0 84.289 24.77 105.3 61.487z",
    fill: "url(#u)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m256.77 209.51c-0.393 5.978-21.514 26.593-28.9 26.593-68.339 0-79.432 41.335-79.432 41.335 3.027 34.81 27.261 63.475 56.611 78.643 1.339 0.692 2.694 1.317 4.05 1.935a132.77 132.77 0 0 0 7.059 2.886 106.74 106.74 0 0 0 31.271 6.031c119.78 5.618 142.99-143.19 56.545-186.41 22.137-3.85 45.115 5.053 57.947 14.067-21.012-36.714-60.25-61.484-105.3-61.484-2.85 0-5.641 0.235-8.442 0.429a120.25 120.25 0 0 0-66.142 25.488c3.664 3.1 7.8 7.244 16.514 15.828 16.302 16.067 58.13 32.705 58.219 34.657z",
    fill: "url(#t)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m256.77 209.51c-0.393 5.978-21.514 26.593-28.9 26.593-68.339 0-79.432 41.335-79.432 41.335 3.027 34.81 27.261 63.475 56.611 78.643 1.339 0.692 2.694 1.317 4.05 1.935a132.77 132.77 0 0 0 7.059 2.886 106.74 106.74 0 0 0 31.271 6.031c119.78 5.618 142.99-143.19 56.545-186.41 22.137-3.85 45.115 5.053 57.947 14.067-21.012-36.714-60.25-61.484-105.3-61.484-2.85 0-5.641 0.235-8.442 0.429a120.25 120.25 0 0 0-66.142 25.488c3.664 3.1 7.8 7.244 16.514 15.828 16.302 16.067 58.13 32.705 58.219 34.657z",
    fill: "url(#s)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m170.83 151.04a244.04 244.04 0 0 1 4.981 3.3 111.34 111.34 0 0 1-0.674-58.732c-24.688 11.241-43.89 29.01-57.85 44.7 1.155-0.033 36.014-0.66 53.543 10.732z",
    fill: "url(#r)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m18.223 261.41c18.543 109.58 117.88 193.24 230.63 196.43 104.36 2.954 171.04-57.62 198.58-116.72 17.8-38.2 30.154-100.7 7.479-162.18l-8e-3 -0.026-0.032-0.233c-0.025-0.178-0.04-0.284-0.036-0.226 0 0.039 0.015 0.136 0.047 0.4 8.524 55.661-19.79 109.58-64.051 146.04l-0.133 0.313c-86.245 70.223-168.77 42.368-185.48 30.966a144.11 144.11 0 0 1-3.5-1.743c-50.282-24.029-71.054-69.838-66.6-109.12-42.457 0-56.934-35.809-56.934-35.809s38.119-27.179 88.358-3.541c46.53 21.893 90.228 3.543 90.233 3.541-0.089-1.952-41.917-18.59-58.223-34.656-8.713-8.584-12.85-12.723-16.514-15.828a71.355 71.355 0 0 0-6.225-4.7 282.93 282.93 0 0 0-4.981-3.3c-17.528-11.392-52.388-10.765-53.543-10.735h-0.111c-9.527-12.067-8.855-51.873-8.312-60.184-0.114-0.515-7.107 3.63-8.023 4.255a175.07 175.07 0 0 0-23.486 20.12 210.48 210.48 0 0 0-22.442 26.919c0 0.012-7e-3 0.026-0.011 0.038 0-0.013 7e-3 -0.026 0.011-0.038a202.84 202.84 0 0 0-32.247 72.805c-0.115 0.521-8.65 37.842-4.44 57.199z",
    fill: "url(#q)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m341.1 166.59a130.71 130.71 0 0 1 22.31 29.112c1.323 0.994 2.559 1.985 3.608 2.952 54.482 50.2 25.936 121.2 23.807 126.26 44.261-36.46 72.575-90.383 64.051-146.04-27.175-67.732-73.254-95.044-110.88-154.51-1.9-3.007-3.805-6.022-5.661-9.2a73.716 73.716 0 0 1-2.646-4.972 43.7 43.7 0 0 1-3.593-9.506 0.626 0.626 0 0 0-0.546-0.644 0.818 0.818 0 0 0-0.451 0c-0.034 0.012-0.084 0.051-0.12 0.065-0.053 0.021-0.12 0.069-0.176 0.1-9.291 4.428-64.407 91.694 10.298 166.39z",
    fill: "url(#p)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m367.02 198.65c-1.049-0.967-2.285-1.958-3.608-2.952-0.489-0.368-0.969-0.734-1.493-1.1-12.832-9.014-35.81-17.917-57.947-14.067 86.441 43.214 63.235 192.03-56.545 186.41a106.74 106.74 0 0 1-31.271-6.031 134.51 134.51 0 0 1-7.059-2.886c-1.356-0.618-2.711-1.243-4.05-1.935 0.048 0.033 0.114 0.07 0.163 0.1 16.71 11.4 99.239 39.257 185.48-30.966l0.133-0.313c2.129-5.054 30.675-76.057-23.807-126.26z",
    fill: "url(#o)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m148.44 277.44s11.093-41.335 79.432-41.335c7.388 0 28.509-20.615 28.9-26.593s-43.7 18.352-90.233-3.541c-50.239-23.638-88.358 3.541-88.358 3.541s14.477 35.809 56.934 35.809c-4.453 39.286 16.319 85.1 66.6 109.12 1.124 0.537 2.18 1.124 3.334 1.639-29.348-15.169-53.582-43.834-56.609-78.644z",
    fill: "url(#n)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m478.71 166.35c-10.445-25.124-31.6-52.248-48.212-60.821 13.52 26.505 21.345 53.093 24.335 72.936 0 0.039 0.015 0.136 0.047 0.4-27.175-67.733-73.254-95.045-110.88-154.51-1.9-3.007-3.805-6.022-5.661-9.2a73.716 73.716 0 0 1-2.646-4.972 43.7 43.7 0 0 1-3.593-9.506 0.626 0.626 0 0 0-0.546-0.644 0.818 0.818 0 0 0-0.451 0c-0.034 0.012-0.084 0.051-0.12 0.065-0.053 0.021-0.12 0.069-0.176 0.1 0.027-0.036 0.083-0.117 0.1-0.136-60.37 35.356-80.85 100.76-82.732 133.48 2.8-0.194 5.592-0.429 8.442-0.429 45.053 0 84.291 24.77 105.3 61.484-12.832-9.014-35.81-17.917-57.947-14.067 86.441 43.214 63.235 192.03-56.545 186.41a106.74 106.74 0 0 1-31.271-6.031 134.51 134.51 0 0 1-7.059-2.886c-1.356-0.618-2.711-1.243-4.05-1.935 0.048 0.033 0.114 0.07 0.163 0.1a144.11 144.11 0 0 1-3.5-1.743c1.124 0.537 2.18 1.124 3.334 1.639-29.35-15.168-53.584-43.833-56.611-78.643 0 0 11.093-41.335 79.432-41.335 7.388 0 28.509-20.615 28.9-26.593-0.089-1.952-41.917-18.59-58.223-34.656-8.713-8.584-12.85-12.723-16.514-15.828a71.355 71.355 0 0 0-6.225-4.7 111.34 111.34 0 0 1-0.674-58.732c-24.688 11.241-43.89 29.01-57.85 44.7h-0.111c-9.527-12.067-8.855-51.873-8.312-60.184-0.114-0.515-7.107 3.63-8.023 4.255a175.07 175.07 0 0 0-23.486 20.12 210.48 210.48 0 0 0-22.435 26.916c0 0.012-7e-3 0.026-0.011 0.038 0-0.013 7e-3 -0.026 0.011-0.038a202.84 202.84 0 0 0-32.247 72.805c-0.115 0.521-0.212 1.061-0.324 1.586-0.452 2.116-2.486 12.853-2.77 15.156-0.022 0.177 0.021-0.176 0 0a279.56 279.56 0 0 0-3.544 33.53c0 0.41-0.025 0.816-0.025 1.227 0 132.71 107.6 240.29 240.32 240.29 118.86 0 217.56-86.288 236.88-199.63 0.407-3.076 0.733-6.168 1.092-9.271 4.777-41.21-0.53-84.525-15.587-120.75zm-23.841 12.341c0.012 0.085 0.027 0.174 0.04 0.259l-8e-3 -0.026-0.032-0.233z",
    fill: "url(#m)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.cccd666ae4ddb63b417cd653bc596fcb.svg";
export { ForwardRef as ReactComponent };